export default __webpack_public_path__ + "3ff623018605c9c1aa22c1e1d7472203.svg";